/*
 * StalkMaster: no size is preselected on the product page.
 *
 * Shopify always opens a product on a variant, so the page loads with a size already active
 * (the first one, S). This script hides that pick until the shopper chooses a size, and stops
 * every way of buying the product (buy button, sticky bar, express checkout) until they do.
 *
 * - Main picker: the size pills show no active pill and no selected value until one is clicked.
 * - Offer tiers: each set's colour/size dropdown opens on "Choose colour & size" until the shopper
 *   picks it, or picks a size in the main picker (offers.js then copies it to every set).
 * - A blocked buy scrolls to what is missing, outlines it and says what to do.
 *
 * Loaded from a Custom Liquid block inside the product's Variant Picker. It runs before the
 * theme's deferred scripts, so its window capture submit listener runs ahead of offers.js.
 */
(function () {
  if (window.SmSizeRequired) return;

  var SIZE_RE = /size/i;
  var TEXT = {
    placeholder: 'Choose colour & size',
    size: 'Choose your size first',
    set: 'Choose colour & size for set #'
  };
  var state = { chosen: false };
  window.SmSizeRequired = state;

  var css = [
    '.sm-size-unset .sugar-variant-picker-option__selected{visibility:hidden}',
    '.sm-size-unset .sugar-variant-picker-option__value.is-active label{background:var(--vo-bg)!important;color:var(--vo-fg)!important;border-color:var(--vo-border)!important;font-weight:var(--vo-weight)!important}',
    '.sm-size-unset .sugar-variant-picker-option__value.is-active .sugar-variant-picker-option__check{display:none!important}',
    '.sm-size-unset .sugar-variant-picker-option__value.is-active .sugar-variant-picker-option__label{outline:none!important;box-shadow:none!important}',
    '.offer__variant-select.sm-size-placeholder{color:#8a2a22;font-weight:700}',
    '.sm-size-attn{outline:2px solid #b3261e!important;outline-offset:4px;border-radius:6px;animation:sm-size-shake .4s ease-in-out 2}',
    '@keyframes sm-size-shake{0%,100%{transform:translateX(0)}25%{transform:translateX(-4px)}75%{transform:translateX(4px)}}',
    '.sm-size-msg{color:#b3261e;font-weight:700;font-size:14px;margin:6px 0}',
    '.sugar-product-buy-button__dc{position:relative}',
    '.sm-dc-shield{display:none;position:absolute;inset:0;z-index:5;cursor:pointer}',
    '.sm-size-needed .sm-dc-shield{display:block}'
  ].join('');
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function visible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function sizeOptions() {
    return Array.prototype.filter.call(
      document.querySelectorAll('.sugar-product-variant-picker .sugar-variant-picker-option'),
      function (el) { return SIZE_RE.test(el.getAttribute('data-option-name') || ''); }
    );
  }

  // Every variant id of the product, from the offer tiers' own list.
  var productIds = null;
  function ids() {
    if (productIds && productIds.size) return productIds;
    productIds = new Set();
    document.querySelectorAll('.sugar-offer[data-offer-variant-ids]').forEach(function (offer) {
      offer.getAttribute('data-offer-variant-ids').split(',').forEach(function (id) {
        if (id.trim()) productIds.add(id.trim());
      });
    });
    document.querySelectorAll('.offer__variant-select option').forEach(function (o) {
      if (o.value) productIds.add(o.value);
    });
    return productIds;
  }

  function isProductForm(form) {
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return false;
    var input = form.querySelector('[name="id"]');
    return !!(input && ids().has(String(input.value)));
  }

  function selectedOffer() {
    return document.querySelector('.sugar-offer.is-selected') || document.querySelector('.sugar-offer[aria-checked="true"]');
  }

  function offerSelects(offer) {
    if (!offer) return [];
    return Array.prototype.filter.call(offer.querySelectorAll('.offer__variant-select'), visible);
  }

  function addPlaceholder(select) {
    var ph = select.querySelector('option[data-sm-placeholder]');
    if (!ph) {
      ph = document.createElement('option');
      ph.value = '';
      ph.disabled = true;
      ph.setAttribute('data-sm-placeholder', '');
      ph.textContent = TEXT.placeholder;
      select.insertBefore(ph, select.firstChild);
    }
    ph.selected = true;
    select.classList.add('sm-size-placeholder');
  }

  function syncPlaceholders() {
    document.querySelectorAll('.offer__variant-select').forEach(function (select) {
      if (!state.chosen && !select.hasAttribute('data-sm-picked')) addPlaceholder(select);
      select.classList.toggle('sm-size-placeholder', select.value === '');
    });
  }

  function syncSizeOptions() {
    sizeOptions().forEach(function (el) { el.classList.toggle('sm-size-unset', !state.chosen); });
  }

  // What still has to be picked before this buy, or null.
  function missing() {
    var offer = selectedOffer();
    var quantity = offer ? parseInt(offer.getAttribute('data-quantity'), 10) || 1 : 1;
    var selects = offerSelects(offer);
    var empty = selects.filter(function (s) { return s.value === ''; });
    if (empty.length) return { el: empty[0], text: quantity > 1 ? TEXT.set + (selects.indexOf(empty[0]) + 1) : TEXT.size };
    if (state.chosen) return null;
    if (quantity > 1 && selects.length) return { el: selects[0], text: TEXT.set + '1' };
    var size = sizeOptions().filter(visible)[0];
    if (size) return { el: size, text: TEXT.size };
    if (selects.length) return { el: selects[0], text: TEXT.set + '1' };
    return null;
  }

  function syncLock() {
    document.documentElement.classList.toggle('sm-size-needed', !!missing());
  }

  function sync() {
    syncSizeOptions();
    syncPlaceholders();
    syncLock();
  }

  function clearPrompts() {
    document.querySelectorAll('.sm-size-msg').forEach(function (m) { m.remove(); });
    document.querySelectorAll('.sm-size-attn').forEach(function (m) { m.classList.remove('sm-size-attn'); });
  }

  function prompt(need) {
    clearPrompts();
    var target = need.el.classList.contains('offer__variant-select')
      ? need.el.closest('.offer__variants-slot') || need.el
      : need.el;
    var msg = document.createElement('p');
    msg.className = 'sm-size-msg';
    msg.setAttribute('role', 'alert');
    msg.textContent = need.text;
    target.parentNode.insertBefore(msg, target);
    target.classList.add('sm-size-attn');
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { target.classList.remove('sm-size-attn'); }, 2500);
  }

  // The shopper picked a size pill in the main picker.
  document.addEventListener('click', function (e) {
    // Only a real tap: theme scripts that restore a variant click pills from code.
    if (!e.isTrusted) return;
    var value = e.target.closest && e.target.closest('.sugar-variant-picker-option__value');
    if (!value) return;
    var option = value.closest('.sugar-variant-picker-option');
    if (!option || !SIZE_RE.test(option.getAttribute('data-option-name') || '')) return;
    if (!option.closest('.sugar-product-variant-picker')) return;
    state.chosen = true;
    clearPrompts();
    // offers.js copies the new variant to every dropdown. Picking the size the page opened
    // on changes no variant, so fill any dropdown still on the placeholder from the form.
    setTimeout(function () {
      var form = document.querySelector('product-form form[action*="/cart/add"]');
      var current = form && form.querySelector('[name="id"]');
      document.querySelectorAll('.offer__variant-select').forEach(function (s) {
        s.setAttribute('data-sm-picked', '');
        if (s.value === '' && current && s.querySelector('option[value="' + current.value + '"]')) s.value = current.value;
        var ph = s.querySelector('option[data-sm-placeholder]');
        if (ph && s.value !== '') ph.remove();
      });
      sync();
    }, 60);
  }, true);

  // The shopper picked a set's colour and size in an offer tier.
  document.addEventListener('change', function (e) {
    var select = e.target;
    if (!select.classList || !select.classList.contains('offer__variant-select')) return;
    select.setAttribute('data-sm-picked', '');
    var ph = select.querySelector('option[data-sm-placeholder]');
    if (ph) ph.remove();
    // offers.js copies slot 1 to the main picker, so a slot pick counts as choosing a size.
    state.chosen = true;
    clearPrompts();
    setTimeout(sync, 0);
  }, true);

  // Choosing another tier, colour or anything that re-renders the picker.
  document.addEventListener('click', function () { setTimeout(sync, 0); });
  document.addEventListener('variant:change', function () { setTimeout(sync, 0); });

  // Buy button, sticky bar and any other add-to-cart form of this product.
  window.addEventListener('submit', function (e) {
    if (!isProductForm(e.target)) return;
    var need = missing();
    if (!need) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    prompt(need);
  }, true);

  // Express checkout buttons can't be stopped from outside their frame: cover them instead.
  function shieldExpress() {
    document.querySelectorAll('.sugar-product-buy-button__dc').forEach(function (dc) {
      if (dc.querySelector('.sm-dc-shield')) return;
      var shield = document.createElement('div');
      shield.className = 'sm-dc-shield';
      shield.setAttribute('aria-hidden', 'true');
      shield.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var need = missing();
        if (need) prompt(need);
      });
      dc.appendChild(shield);
    });
  }

  function init() {
    shieldExpress();
    sync();
  }

  init();
  document.addEventListener('DOMContentLoaded', init);
  // offers.js sets every tier's dropdowns when it starts, after this script.
  window.addEventListener('load', function () { init(); setTimeout(init, 300); });

  // The picker and the sticky bar re-render on a variant change.
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      shieldExpress();
      if (!state.chosen) { syncSizeOptions(); syncPlaceholders(); }
      syncLock();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
